module.exports = "/static/assets/eef2db022a11a91cf48257e10f01ee05.png";